import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const HistoryTable = ({ params, report, onActionsPopup }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} key={index} onActionsPopup={onActionsPopup}/>));

    return (
        <Table bordered responsive>
            <Head params={params} />
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default HistoryTable;



// WEBPACK FOOTER //
// ./src/scenes/History/components/Table/index.js